<template>
  <div class="VstudentTitleCard">
     <!-- v-if="studentList.length>0" -->
   <div class="center">
   <div class="center_top">
            <div class="studentName">{{studentInfo.studentName||''}}</div>
            <div class="changeBox">
            <van-popover   v-model="showPopover"  trigger="click" :actions="studentList" @select="onSelectPopover">
              <template #reference>
                <van-icon name="descending" />
              </template>
            </van-popover>
            </div>
            <div style="font-size: 10px;">
              <!-- Hi,欢迎您使用龙猫校园 -->
            </div>
       
   </div>
        <div class="hintBox">
                  
                  <!-- <div v-if="+studentStatusData.faceStatus==1&&+studentStatusData.homeStatus!==2"> Hi,欢迎您使用</div> -->
                  <div v-if="+studentStatusData.faceStatus==1&&+studentStatusData.homeStatus!==2">  Hi,欢迎您使用</div>
                  <!-- <div  class="hintBox_text" v-if="+studentStatusData.faceStatus==0" style="color:red;" @click="goadmissionTicket()">学生未制证<van-icon name="warning" /></div> -->
                  <span  class="hintBox_text" v-if="+studentStatusData.faceStatus==0" style="color:red;" @click="goadmissionTicket()">未制证<van-icon name="warning" /> &nbsp;</span>
                  <span  class="hintBox_text" v-if="+studentStatusData.homeStatus==2" style="color:red;" @click="goHomework()">新作业<van-icon name="warning" /></span> 
            </div>

<!-- 返参 faceStatus (0, 无人脸 ,1, 有人脸 ) -->
<!-- homeStatus (0,无作业任务,1,已提交,2,未提交) -->
   

      <!-- <slot name="btn"/> -->

      <!-- <div class="className">{{studentInfo.studentGradeName||''}}  {{studentInfo.adminClassName||''}}</div> -->

      </div>
      <div class="rightbox" @click="onRightbox">
          <div class="scorebox"  :style="{color: colors[studentStatusData.level]}">
            {{ (+studentStatusData.totalPoints).toFixed(0) ||'00' }}
          </div>
      </div>

      <van-popup v-model:show="showQRDialog" width="80%"  get-container="body" >
    <div >
    <vue-qr style="margin: 0 atuo;" :text="studentInfo.snCode+'&&'+studentInfo.schoolCode" :logoSrc="require('@/assets/background/loginLog.jpg')"   :margin='8'></vue-qr>
    </div>
  </van-popup>
  </div>
  </template>
  <script>
  import { getChildInfoBySnCode} from "@/api/common.js";
  import vueQr from 'vue-qr'
  import { getChildInfoList} from "@/api/studentBind.js";
   import { setSession ,getSession} from "@/utils/cookie";
  
  export default {
    name: 'VstudentTitleCard',
    components: {vueQr},
    props: {
    // 文本
      icon: {
        type: String,
        default: '',
      },
      
      // snCode: {
      //   type: String,
      //   default: "",
      // },
       schoolCode: {
        type: String,
        default: "",
      },
      // 当已有学生信息的时候可以选择传入学生信息
      propsStudentInfo: {
        type: Object,
        default: ()=>{},
      },
      // 是否显示审核状态
      isStatus:{
        type: Boolean,
        default: false,
      },
      // 是否显示切换按钮
      isChange:{
        type: Boolean,
        default: false,
      },
       // 学生信息
      studentStatusData: {
        type: Object,
        default: ()=>{},
      },


   
      
    },
  
    watch:{
      snCode:{
            immediate: true,
        handler: async function(val) {
          console.log(val);
              if (val&&val!=='') {
              console.log(val);
                  // this.getChildInfoBySnCode()
              }
      }
          
      },
      propsStudentInfo:{
            immediate: true,
        handler: async function(val) {
          console.log(val);
              if (val&&val!==''&&!this.snCode&&this.snCode=='') {
              console.log(val);
              this.studentInfo =val
              }
        }
      },
      studentInfo:{
            immediate: true,
            handler: async function(val) {
              if (val&&val.snCode&&val.snCode!=='') {
                 this.$emit('change',val)
              }
        }
      },
    },
    data() {
      return {
        colors:{
        '不及格':'#f16114',
        '及格':'#f3a919',
        '良好':'#1ea5eb',
        '优秀':'#0eb56c',
      },
          showQRDialog:false,
          studentInfo:{
              snCode:''
          },
          studentList:[],
          showPopover:false
      }
    },
  
    created() {
  
    },
    mounted () {
      this.getChildInfoList()
    },
    methods: {
      goHomework(){
      this.$router.push({path:'homework'})
      },
      goadmissionTicket(){
      this.$router.push({path:'admissionTicket'})
      },
      onRightbox(){
        this.$emit('onRightbox')
      },
      onSelectPopover(action){
        console.log(action);
      this.studentInfo = action
      setSession('studentTitleCard',JSON.stringify(this.studentInfo))
      // this.$emit('change',action)
      },
          getChildInfoList(){
  getChildInfoList({
    status:'-1'
  }).then(res=>{
    console.log(123,res);
    
    if (!res.data.data||res.data.data.length==0) {

                this.$dialog
                  .alert({
                  title:'提示',
                  message: '暂未绑定孩子信息，请先绑定！',
                  showCancelButton: false
                  }).then(() => {
      this.$router.push({path:'guidePage'})
                  })
                  return
    }
      res.data.data?.forEach(el=>{
        this.$set(el,'text', el.studentName)
    })
    this.studentList = res.data.data
    this.studentInfo = this.studentList[0]
  
    if (getSession('studentTitleCard')) {
     this.studentInfo =  JSON.parse(getSession('studentTitleCard'))
    }else{
    setSession('studentTitleCard',JSON.stringify(this.studentInfo))
    }
  
    
  }).catch(()=>{
         this.$dialog
                  .alert({
                  title:'提示',
                  message: '暂未绑定孩子信息，请先绑定！',
                  showCancelButton: false
                  }).then(() => {
      this.$router.push({path:'guidePage'})
                  })
  })
      },
        onshowQr(item){
        console.log(1);
        this.showQRDialog =true
      },
      getChildInfoBySnCode(){
      getChildInfoBySnCode({
          snCode:this.snCode,
          schoolCode:this.schoolCode,
          }).then(res=>{
          console.log(res);
          this.studentInfo =res.data.body
          })
      },
     buttonCustomClick() {
      this.$emit("click");
    }
    },
  }
  </script>
  
  <style lang="less" scoped>
@font-face {
    font-family: DIN-BlackItalic;
   src: url(../assets/font/DIN-BlackItalic.otf);
}
    .VstudentTitleCard {
      display: flex;
      justify-content: space-between;
      .center{
        display: flex;
        flex-direction: column;
        align-content: space-between;
        justify-content: space-between;
           width: 58vw;
           height: 21vw;
           padding: 2.5%;
          position: relative;
          color: #fff;
          border-radius: 15px;
          background-image: url('../assets/parentImg/男title.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          .hintBox{
            position: absolute;
            left: 12vw;
            bottom: 9vw;
            font-size: 12px;
            color: #57a2db;
          }
          .hintBox_text{
              text-decoration: underline; /* 基础下划线 */
              // text-decoration: underline dotted; /* 点状下划线 */
              // text-decoration: underline wavy; /* 波浪线下划线 */
              text-decoration-color: red; /* 自定义下划线颜色 */
          }
    .center_top{
      display: flex;
      align-items: center;
    }
    .changeBox{
      // position: absolute;
      // top: 3px;
      // right: 6px;
    }
          .studentName{
            font-size: 4.8vw;
            font-weight: bold;
            margin-bottom: 5px;
            margin-right: 8px;
          }
          .schoolName{
            font-size: 3vw;
            margin: 5px 0 2px 0;
          }
          .className{
            font-size: 3vw;
            text-align: left;
          }
          .isStatusClass{
            position: absolute;
            right: 30px;
            top: 10px;
            // transform: rotate(45deg);
          }
          .onchangeClass{
            font-size: 4vw;
            font-weight: 600;
            // margin-left: 10px;
          }
          .center_value{
              color: #bbb;
          }
        
      }
      .rightbox{
        position: relative;
        width: 26vw;
        height: 26vw;
        border-radius: 10px;
         background-image: url('../assets/parentImg/运动诊断.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .scorebox{
          position: absolute;
          bottom: 20px;
          right: 12px;
          // color: #ffe71c;
          font-family: DIN-BlackItalic;
          font-size: 40px;
          font-weight: 700;
        }
      }
      .text_l{
      text-align: left;
      text-overflow:ellipsis;
      overflow:hidden;
  
      
  }
  .text_c{
      text-align: center;
  }
    }
  
  /* 针对小屏幕（如手机）的样式 */
@media (max-width: 600px) {
  .rightbox {
    width: 60vw;  /* 设置为视口宽度的60% */
    height: 60vw; /* 设置为视口宽度的60% */
  }
}

/* 针对大屏幕的样式 */
@media (min-width: 1200px) {
  .rightbox {
    width: 10vw;
    height: 10vw;
  }
}
  </style>
  